import * as React from "react";
const SvgComment24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 22,
        fill: "black",
        viewBox: "0 0 20 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 0h20v16h-8.643L4.5 21.61V16H0V0Zm2 2v12h4.5v3.39L10.643 14H18V2H2Z",
      clipRule: "evenodd"
    })
  );
export default SvgComment24Px;
